import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { IS_JEST, DEV_MODE } from '../../utils/Constants';
import useAuthUtils from '../../utils/useAuthUtils';
import { faker } from '@faker-js/faker';
import Button from '../../components/controls/Button';
import { TextParagraph } from '../../components/controls/Typography/TextBody';
import { From } from '../../components/controls/Form';
import Heading from '../../components/controls/Typography/Heading';

import './extras.less';

export const SuccessDeclineWithoutAcc = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuthUtils();

  const { title = null, email = null, pdfDownloadLink = null } = location.state ?? (IS_JEST || DEV_MODE ? {
    title: faker.lorem.words(5),
    email: faker.internet.exampleEmail(),
    pdfDownloadLink: faker.internet.url(),
  } : {});

  const doCreateAccount = () => {
    auth.doRegister();
  };

  useEffect(() => {
    document.title = 'Letters Portal - Guest Access';
    IS_JEST || DEV_MODE || title ? void 0 : navigate('/notFound');
  }, []);

  return (
    <main className="lsn-page lsn-page-success lsn-page-success-decline-without-acc">
      <Heading className="text-center no-focus-outline" tabIndex={0}>
        {title}
      </Heading>

      {pdfDownloadLink ? (
        <div className="lsn-download-btn text-center">
          <Button
            primary
            ghost
            icon={<i className="far fa-download"></i>}
            onClick={() => {
              window.open(pdfDownloadLink, '_blank');
            }}
          >
            Download a pdf
          </Button>
        </div>
      ) : null}


      <From
        title='Would you like to Create an Account?'
        classNameForm='guest-submission-container'
        isNarrow
        hasBorder
        isButtonsStack
        buttons={<>
          <Button
            primary
            onClick={() => doCreateAccount()}
          >
            Create an Account
          </Button>

          <Button
            ghost
            onClick={() => auth.doLogout({
              onComplete: () => window.close()
            })}
          >
            No thanks, close this window.
          </Button>
        </>}
      >

        <ul>
          <li>
            <i className="far fa-clock"></i>Access requests quickly
          </li>
          <li>
            <i className="far fa-save"></i>Save and complete anytime
          </li>
          <li>
            <i className="far fa-list-alt"></i>View and track requests in one location
          </li>
        </ul>

        <TextParagraph>
          Creating an account will also show you an archive of all recommendations associated with the email
          address&nbsp;
          <strong>{email ?? ''}.</strong>
        </TextParagraph>
      </From>

    </main>
  );
};

export default SuccessDeclineWithoutAcc;
